import urls from "../../constants/urls.js";
import axios from "axios";

const state = {
  eligibleCampaigns: [],
  loadingEligibleCampaigns: false,
};

const getters = {
  getEligibleCampaigns: (state) => state.eligibleCampaigns,
  getLoadingEligibleCampaigns: (state) => state.loadingEligibleCampaigns,
};

const mutations = {
  setEligibleCampaigns(state, data) {
    state.eligibleCampaigns = data;
  },

  setLoadingEligibleCampaigns(state, value) {
    state.loadingEligibleCampaigns = value;
  },

  removeEligibleCampaign(state, campaignId) {
    state.eligibleCampaigns = state.eligibleCampaigns.filter(
      (item) => item.campaign_id !== campaignId
    );
  },
};

const actions = {
  getEligibleCampaigns({ commit }) {
    commit("setLoadingEligibleCampaigns", true);

    let orgId = localStorage.getItem("orgId");
    return axios
      .get(urls.eligibleCampaigns(orgId))
      .then((response) => {
        let eligibleCampaignsData = Array.isArray(response.data) ? response.data : [];
        commit("setEligibleCampaigns", eligibleCampaignsData);
        commit("setLoadingEligibleCampaigns", false);
        return eligibleCampaignsData;
      })
      .catch((e) => {
        console.log(e);
        commit("setEligibleCampaigns", []);
        commit("setLoadingEligibleCampaigns", false);
        return [];
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
